import React from 'react'
import PropTypes from 'prop-types'
import { default as formsConfig } from '../utils/formsConfig'

class InfusionsoftForm extends React.Component {
  static propTypes = {
    configKey: PropTypes.string.isRequired,
  }

  // From formsConfig:

  // // "https://wo246.infusionsoft.com/app/form/process/fd728998b73bee0d818f2c66ef35deac"
  //   action: PropTypes.string.isRequired,
  //   // "inf_form_fd728998b73bee0d818f2c66ef35deac"
  //   formId: PropTypes.string.isRequired,
  //   // "fd728998b73bee0d818f2c66ef35deac"
  //   inf_form_xid: PropTypes.string.isRequired,
  //   // "Website Homepage&#a;Free Report Request"
  //   inf_form_name: PropTypes.string.isRequired,
  //   // "1.70.0.76272"
  //   infusionsoft_version: PropTypes.string.isRequired,
  //   // key from forms config

  // NOTE: Be sure to include the correct ids for the inputs and buttons
  // <button class="infusion-recaptcha" id="recaptcha_fd728998b73bee0d818f2c66ef35deac" type="submit">Submit</button>

  render() {
    const { configKey, ...otherProps } = this.props
    const {
      action,
      formId,
      inf_form_xid,
      inf_form_name,
      infusionsoft_version,
    } = formsConfig[configKey] || {}
    return (
      <form
        acceptCharset="UTF-8"
        action={action}
        id={formId}
        method="POST"
        {...otherProps}
      >
        <input name="inf_form_xid" type="hidden" value={inf_form_xid} />
        <input name="inf_form_name" type="hidden" value={inf_form_name} />
        <input
          name="infusionsoft_version"
          type="hidden"
          value={infusionsoft_version}
        />
        {this.props.children}
        <script
          defer
          async
          type="text/javascript"
          src="https://wo246.infusionsoft.com/app/webTracking/getTrackingCode"
        ></script>
        <script
          defer
          async
          type="text/javascript"
          src={`https://wo246.infusionsoft.com/resources/external/recaptcha/production/recaptcha.js?b=${infusionsoft_version}`}
        ></script>
        <script
          defer
          async
          src="https://www.google.com/recaptcha/api.js?onload=onloadInfusionRecaptchaCallback&render=explicit"
        ></script>
        <script
          defer
          async
          type="text/javascript"
          src={`https://wo246.infusionsoft.com/app/timezone/timezoneInputJs?xid=${inf_form_xid}`}
        ></script>
      </form>
    )
  }
}

export default InfusionsoftForm
